import { Modal, SubmitButton } from "@xola/ui-kit";
import { now } from "common";
import React from "react";
import { ExperiencePurchaseItem } from "types";
import { useVisibility } from "../../hooks/useVisibility";
import { RadioInput } from "../Common/RadioInput";
import { SecondaryButton } from "../Common/SecondaryButton";

interface GuestNoShowModalProps {
    purchaseItem: ExperiencePurchaseItem;
    guestId: ID;
    count: number;
    onClose: () => void;
    isOpen: boolean;
    onConfirm: (doNotIncreaseAvailability: boolean, id: ID) => void;
    isLoading: boolean;
}

export const GuestNoShowModal = ({
    guestId,
    count,
    onClose,
    isOpen,
    onConfirm,
    isLoading,
    purchaseItem,
}: GuestNoShowModalProps) => {
    return (
        <Modal isOpen={isOpen} size="medium" onClose={onClose}>
            <ModalContent
                guestId={guestId}
                count={count}
                purchaseItem={purchaseItem}
                isLoading={isLoading}
                onClose={onClose}
                onConfirm={onConfirm}
            />
        </Modal>
    );
};

type ModalContentProps = Omit<GuestNoShowModalProps, "isOpen">;

const ModalContent = ({ guestId, count, onClose, onConfirm, isLoading, purchaseItem }: ModalContentProps) => {
    const [doNotIncreaseAvailability, { hide, show }] = useVisibility(false);

    const isPastEvent = purchaseItem?.arrivalDateTime ? now().isAfter(purchaseItem.arrivalDateTime) : false;

    const handleConfirm = () => {
        onConfirm(doNotIncreaseAvailability, guestId);
        onClose();
    };

    return (
        <>
            <Modal.Header>Confirm {!isPastEvent && "Future"} No Show</Modal.Header>

            <Modal.Body>
                <div>
                    <div className="mb-10 text-center">
                        <span>
                            You are attempting to mark a {!isPastEvent && "future"} reservation as a no-show. How do you
                            want to handle availablity for the seats marked as no-show?
                        </span>
                    </div>
                    <div>
                        <RadioInput checked={!doNotIncreaseAvailability} onChange={hide}>
                            Increase the availability of event by <var data-var="count">{count}</var>
                        </RadioInput>

                        <RadioInput checked={doNotIncreaseAvailability} onChange={show}>
                            Do not increase availability
                        </RadioInput>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="flex justify-end">
                <SecondaryButton disabled={isLoading} onClick={onClose}>
                    Cancel
                </SecondaryButton>
                <SubmitButton isLoading={isLoading} onClick={handleConfirm}>
                    Confirm
                </SubmitButton>
            </Modal.Footer>
        </>
    );
};
